import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/pip.tsx
var Pip = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M9.25 16.75H4.75C3.64543 16.75 2.75 15.8546 2.75 14.75V6.25C2.75 5.14543 3.64543 4.25 4.75 4.25H17.25C18.3546 4.25 19.25 5.14543 19.25 6.25V10.75M14.25 14.25H19.75C20.5784 14.25 21.25 14.9216 21.25 15.75V18.25C21.25 19.0784 20.5784 19.75 19.75 19.75H14.25C13.4216 19.75 12.75 19.0784 12.75 18.25V15.75C12.75 14.9216 13.4216 14.25 14.25 14.25Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M3.5 6.25C3.5 5.55964 4.05964 5 4.75 5H17.25C17.9404 5 18.5 5.55964 18.5 6.25V10.75C18.5 11.1642 18.8358 11.5 19.25 11.5C19.6642 11.5 20 11.1642 20 10.75V6.25C20 4.73122 18.7688 3.5 17.25 3.5H4.75C3.23122 3.5 2 4.73122 2 6.25V14.75C2 16.2688 3.23122 17.5 4.75 17.5H9.25C9.66421 17.5 10 17.1642 10 16.75C10 16.3358 9.66421 16 9.25 16H4.75C4.05964 16 3.5 15.4404 3.5 14.75V6.25Z",
		fill: "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		d: "M14.25 13.5C13.0074 13.5 12 14.5074 12 15.75V18.25C12 19.4926 13.0074 20.5 14.25 20.5H19.75C20.9926 20.5 22 19.4926 22 18.25V15.75C22 14.5074 20.9926 13.5 19.75 13.5H14.25Z",
		fill: "currentColor"
	})] })
});
//#endregion
export { Pip };
